const timelineItems = [
    {
        id: "lenguas-inauguracion",
        badge: "29 de Septiembre de 1934",
        badgeClass: "bg-red-500/20 text-red-400",
        markerClass: "bg-red-500",
        panelClass: "border-red-500/20 bg-[#221010] ring-1 ring-red-500/20 shadow-lg shadow-red-500/5 hover:bg-[#2a1414]",
        title: "Inauguración de la Cancha de Lenguas",
        description:
            "Se inaugura oficialmente el primer escenario propio en Dr. Luis P. Lenguas 1414 (entre José L. Terra y Sierra), frente al Palacio Legislativo. El partido inaugural es con victoria ante el Club Nacional de Regatas.",
    },
    {
        id: "ciclo-oro",
        badge: "1940s",
        badgeClass: "bg-green-500/20 text-green-400",
        markerClass: "bg-green-500",
        panelClass: "border-green-500/20 bg-[#102216] ring-1 ring-green-500/20 shadow-lg shadow-green-500/5 hover:bg-[#15301d]",
        title: "El cuatrienio de oro",
        description:
            "Bajo la presidencia de Daniel Fernández Crespo, la cancha de Lenguas es testigo de una de las eras más gloriosas del básquetbol uruguayo: Aguada conquista cuatro títulos consecutivos, un récord histórico igualado pero jamás superado.",
    },
    {
        id: "transicion",
        badge: "Transición",
        badgeClass: "bg-red-500/20 text-red-400",
        markerClass: "bg-red-500",
        panelClass: "border-red-500/20 bg-[#221010] ring-1 ring-red-500/20 shadow-lg shadow-red-500/5 hover:bg-[#2a1414]",
        title: "Desalojo y Plaza N° 2",
        description:
            "Debido a las obras para construir los jardines circundantes al Palacio Legislativo, Aguada pierde su mítica cancha. Durante la búsqueda de alternativas, el plantel entrena temporalmente en la Plaza N° 2 (Gral. Flores y Juan José de Amézaga).",
    },
    {
        id: "fraga",
        badge: "1948",
        badgeClass: "bg-green-500/20 text-green-400",
        markerClass: "bg-green-500",
        panelClass: "border-green-500/20 bg-[#102216] ring-1 ring-green-500/20 shadow-lg shadow-green-500/5 hover:bg-[#15301d]",
        title: "La Cancha de Fraga",
        description:
            "Con el firme objetivo de no dejar el barrio, se arrienda un predio de la firma Oyama en la calle Fraga (entre Enriqueta Compte y Riqué y Martín García). En este escenario, Aguada se consagra campeón del torneo de 1948. Hoy en día, allí se ubican Radio Sarandí y Canal 12.",
    },
    {
        id: "fin-etapa",
        badge: "Febrero de 1950",
        badgeClass: "bg-red-500/20 text-red-400",
        markerClass: "bg-red-500",
        panelClass: "border-red-500/20 bg-[#221010] ring-1 ring-red-500/20 shadow-lg shadow-red-500/5 hover:bg-[#2a1414]",
        title: "Fin de una etapa",
        description:
            "Se devuelve el predio de la calle Fraga y el club vuelve a comenzar una intensa y por momentos agotadora búsqueda de un lugar definitivo.",
    },
    {
        id: "hogar",
        badge: "12 de Enero de 1951",
        badgeClass: "bg-green-500/20 text-green-400",
        markerClass: "bg-green-500",
        panelClass: "border-green-500/20 bg-[#102216] ring-1 ring-green-500/20 shadow-lg shadow-green-500/5 hover:bg-[#15301d]",
        title: "Nace el hogar actual: San Martín",
        description:
            "Bajo la presidencia de Roberto Infante, se firma la escritura para comprar el predio de la Avenida San Martín con fondo a Marmarajá. El lugar era conocido popularmente como \"El Conventillo\".",
    },
    {
        id: "mistica-san-martin",
        badge: "1951 en adelante",
        badgeClass: "bg-red-500/20 text-red-400",
        markerClass: "bg-red-500",
        panelClass: "border-red-500/20 bg-[#221010] ring-1 ring-red-500/20 shadow-lg shadow-red-500/5 hover:bg-[#2a1414]",
        title: "La mística de San Martín",
        description:
            "Comienza una lenta y sacrificada construcción. Los históricos tablones, tableros y barandas que se usaron en Lenguas y en Fraga se trasladan para armar la nueva cancha. Mientras los vecinos del predio se mudaban paulatinamente, los aros convivían día a día con las habitaciones en una hermosa obra colectiva.",
    },
];

function CanchasTimeline() {
    return (
        <section className="relative space-y-12 pb-12 before:absolute before:left-[11px] before:top-0 before:bottom-0 before:w-[2px] before:bg-[#1a3a2a]">
            {timelineItems.map((item) => (
                <article key={item.id} className="relative pl-10">
                    <div className={`absolute left-0 top-1.5 z-10 h-6 w-6 rounded-full border-4 border-[#062a1a] ${item.markerClass}`} />

                    <div className={`rounded-xl border p-6 transition-all ${item.panelClass}`}>
                        <div>
                            <div>
                                <span className={`inline-block rounded px-3 py-1 text-xs font-bold uppercase tracking-wider ${item.badgeClass}`}>
                                    {item.badge}
                                </span>
                                <h3 className="mt-3 text-lg sm:text-xl font-bold text-white">{item.title}</h3>
                            </div>
                        </div>

                        <p className="mt-3 leading-relaxed text-slate-400">{item.description}</p>

                    </div>
                </article>
            ))}
        </section>
    );
}

export default CanchasTimeline;
